import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Image1 from "./assets/61.png";
import Image2 from "./assets/72.png";
import Image3 from "./assets/83.png";
// import Image4 from "./assets/4.webp";
import Image4 from "./assets/92.png";
// import Image5 from "./assets/5.webp";
import Image5 from "./assets/101.png";
import MobileImage2 from "./assets/mobile/image11.png";
import MobileImage1 from "./assets/mobile/image2.png";
import MobileImage3 from "./assets/mobile/image3.png";
import MobileImage4 from "./assets/mobile/image4.png";
import MobileImage5 from "./assets/mobile/image51.png";
import "./App.css";
import Header from "./components/Header";
import Slider from "./components/Slider";
import Counts from "./components/Counts";
import About from "./components/About";
import CompletedPlotProjects from "./components/CompletedProjects";
import UpcomingPlotProjects from "./components/UpcomingProjects";
import Plots from "./components/Plots";
import Locations from "./components/Locations";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import VideoPage from "./components/VideoPage";
import ContactMap from "./components/ContactMap";
import PopupForm from "./components/PopupForm";
import OnGoingProjects from "./components/OnGoing";
import Navbar from "./components/Navbar";

function App() {
  const images = [Image1, Image2, Image3, Image4, Image5];
  const mobileImages = [
    MobileImage3,
    MobileImage4,
    MobileImage2,
    MobileImage1,
    MobileImage5,
  ];
  const laptopImages = [Image1, Image2, Image3, Image4, Image5];
  const effects = ["fade", "coverflow", "flip", "zoom", "rotate"];

  return (
    <div className="App">
      <section id="popup">
        <PopupForm />
      </section>
<Navbar/>
      {/* <Header /> */}
      <section id="home">
        <Slider
          images={images}
          mobileImages={mobileImages}
          laptopImages={laptopImages}
          effects={effects}
          interval={5000}
        />
      </section>
      <section id="about">
        {/* <Counts /> */}
        <About />
        <VideoPage />
      </section>
      <section id="ongoingProjects">
        <OnGoingProjects />
      </section>

      <section id="completedProjects">
        <CompletedPlotProjects />
      </section>
      <section id="upcomingProjects">
        <UpcomingPlotProjects />
      </section>
      <section id="plots">
        <Plots />
      </section>
      <section id="locations">
        <Locations />
      </section>
      <section id="contact">
        <ContactMap />
      </section>

      <Footer />
      <WhatsAppButton />
      {/* <Router>
         <Routes>
          <Route path="/about" element={<About />} />
         </Routes>
        </Router> */}
    </div>
  );
}

export default App;
